
function make_feedback($iGroup, $iP4s, $iMode = 0, $sNextUrl = '', $iIsUploadListenerCard = 0, $iIsUploadProdChar = 0) { // $iMode = 0 - после сдачи экзамена, $iMode = 1 - перед сдачей экзамена, $sNextUrl - перебросить на этот урл после прохождения всех шагов в Swal

    let id = parseInt($iP4s);
    let group_id = parseInt($iGroup);
    $iMode = parseInt($iMode);
    $iIsUploadListenerCard = parseInt($iIsUploadListenerCard);
    $iIsUploadProdChar = parseInt($iIsUploadProdChar);
    $sNextUrl = String($sNextUrl);

    group_id = isNaN(group_id)?0:group_id;
    id = isNaN(id)?0:id;
    $iMode = isNaN($iMode)?0:$iMode;

    $iIsUploadListenerCard = isNaN($iIsUploadListenerCard)?0:$iIsUploadListenerCard;
    $iIsUploadProdChar = isNaN($iIsUploadProdChar)?0:$iIsUploadProdChar;

    if($sNextUrl == "undefined" || $sNextUrl == "NaN" || $sNextUrl == "null") $sNextUrl = "";


    let sPostFix = "";

    if ($iMode == 1) {
        sPostFix = " после сдачи экзамена";
    }

    let aQueue = [];

    if($iMode == 0){
        aQueue.unshift(
            {
                title: 'Оцените качество курса',
                text: 'Поставьте оценку от 1 до 5',
            },
            {
                title: 'Оцените информативность обучения',
                text: 'Поставьте оценку от 1 до 5',
            },
            {
                title: 'Оцените актуальность информации',
                text: 'Поставьте оценку от 1 до 5',
            },
        );
    }

    let aProgressSteps = [];

    if (id != 0) {



        if($iIsUploadProdChar == 0){
            aQueue.unshift(
                {
                    title: 'Прикрепите производственную характеристику',
                    html: `
                  <p>
                  Если Вам сейчас неудобно работать с карточкой, Вы можете это сделать в разделе <a href="/q/external_training/udo_listener_card_production_characteristic">"Производственная характеристика"</a>${sPostFix}.
                  </p>`,
                    input: 'file',
                    inputAttributes: {
                        //'accept': 'image/*',
                        'aria-label': 'Загрузите карточку',
                        'name': 'upload_udo_listener_card'
                    },
                    preConfirm: () => {
                        Swal.showLoading()
                        const file = document.querySelector('input[type="file"]').files[0];
                        if (!file) return true;

                        let formData2 = new FormData();
                        formData2.append('upload_udo_listener_card_prod_char', file);
                        formData2.append('report_id', 58);
                        formData2.append('id', id);
                        formData2.append('input_name', 'upload_udo_listener_card_prod_char');
                        formData2.append('external_source', '`persons4services`');

                        $.ajax({
                            url: '/save_report',
                            type: 'post',
                            data: formData2,
                            contentType: false,
                            processData: false,
                            success: function(response) {
                                Swal.hideLoading()
                                if (response.status == 'success')
                                    toastr.success(response.message);
                                else if (response.status == 'warning')
                                    toastr.info(response.message);
                                else
                                    toastr.error(response.message);
                            },
                        });
                    },
                }
                );
        }

        /*if($iIsUploadListenerCard == 0){
            aQueue.unshift(
                {
                    title: 'Прикрепите карточку слушателя',
                    html: `
                  <p>
                  Если Вам сейчас неудобно работать с карточкой, Вы можете это сделать в разделе <a href="/q/external_training/listener_cards">"Карточки слушателя"</a>${sPostFix}.
                  </p>`,
                    input: 'file',
                    inputAttributes: {
                        //'accept': 'image/!*',
                        'aria-label': 'Загрузите карточку',
                        'name': 'upload_udo_listener_card'
                    },
                    preConfirm: () => {
                        Swal.showLoading()
                        const file1 = document.querySelector('input[type="file"]').files[0];
                        if (!file1) return true;

                        let formData1 = new FormData();
                        formData1.append('upload_udo_listener_card', file1);
                        formData1.append('report_id', 36);
                        formData1.append('id', id);
                        formData1.append('input_name', 'upload_udo_listener_card');
                        formData1.append('external_source', '`persons4services`');

                        $.ajax({
                            url: '/save_report',
                            type: 'post',
                            data: formData1,
                            contentType: false,
                            processData: false,
                            success: function(response) {
                                Swal.hideLoading()
                                if (response.status == 'success')
                                    toastr.success(response.message);
                                else if (response.status == 'warning')
                                    toastr.info(response.message);
                                else
                                    toastr.error(response.message);
                            },
                        });
                    },
                }
            );
        }*/

        if($iIsUploadProdChar == 0){
            aQueue.unshift(
                {
                    title: 'Скачайте и заполните производственную характеристику',
                    html: `
                  <div class="text-center">
                  <p>
                  Если Вам сейчас неудобно работать с карточкой, Вы можете это сделать в разделе <a href="/q/external_training/udo_listener_card_production_characteristic">"Производственная характеристика"</a>${sPostFix}.
                  </p>
                    <button class="btn btn-lg btn-warning " type="button">
                        <a href="/certifications/generate/58/${id}/services" target="_blank" style="color: #fff">
                          Скачать
                          <i class="icon md-cloud-download"></i>
                        </a>
                    </button>
                  </div>
                  `,
                    input: ''
                }
            );
        }

        /*if($iIsUploadListenerCard == 0){
            aQueue.unshift(
                {
                    title: 'Скачайте и заполните карточку слушателя',
                    html: `
                  <div class="text-center">
                  <p>
                  Если Вам сейчас неудобно работать с карточкой, Вы можете это сделать в разделе <a href="/q/external_training/listener_cards">"Карточки слушателя"</a>${sPostFix}.
                  </p>
                    <button class="btn btn-lg btn-warning " type="button">
                        <a href="/certifications/generate/36/${id}/services" target="_blank" style="color: #fff">
                          Скачать
                          <i class="icon md-cloud-download"></i>
                        </a>
                    </button>
                  </div>
                  `,
                    input: ''
                }
            );
        }*/


    }
    aProgressSteps = aQueue.map((el, index) => index + 1);

    Swal.mixin({
            input: 'radio',
            inputOptions: {
                1: "1",
                2: "2",
                3: "3",
                4: "4",
                5: "5",
            },
            confirmButtonText: 'Далее &rarr;',
            cancelButtonText: 'Закрыть',
            showCancelButton: true,
            allowEscapeKey: false,
            allowOutsideClick: false,
            inputValue: 5,
            progressSteps: aProgressSteps,
        }).queue(aQueue)
        .then((result) => {
            if (result.value && $iMode == 0) {
                let assesments = result.value;
                if (id != 0) {
                    assesments = assesments.filter(function(item) {
                        return !isNaN(parseInt(item))
                    })
                }
                const answers = JSON.stringify(assesments);

                $.post('/lms/feedback/send', { group_id: group_id, assesment: answers, },
                    function(data) {
                        Swal.fire({
                            icon: data.status,
                            title: data.message,
                            confirmButtonText: 'Закрыть',
                        });
                        $('.btn-make_feedback').remove();
                    }
                );
            }
            if ($iMode == 1) {
                window.location.href = $sNextUrl;
            }
        });
}

$(document).on('click', '.start_exam_btn_feedback', function() {

    let group = parseInt($(this).data('group'));
    let p4s = parseInt($(this).data('p4s'));
    let mode = parseInt($(this).data('mode'));
    let nexturl = String($(this).data('nexturl'));
    let upload_listener_card = parseInt($(this).data('listenercard'));
    let upload_prod_char = parseInt($(this).data('prodchar'));

    make_feedback(group, p4s, mode, nexturl, upload_listener_card, upload_prod_char);

});
